import instance from 'api';
import { IPositionModel, IUserModel } from 'interfaces';
import { ISettingsGroups, ISettings } from './interfaces';
import { AxiosRequestConfig } from 'axios';

export const getAppSettings = () => {
  return instance()
    .get<ISettingsGroups>('/appSettings/list')
    .then((response) => response.data);
};

export const saveAppSettings = (data: Pick<ISettings<any, any>, 'key' | 'value'>[]) => {
  return instance()
    .post<void>('/appSettings/update', data)
    .then((response) => response.data);
};

// dictionaries
export const getPositions = () => {
  return instance()
    .post<IPositionModel[]>('/dictionary/positions', {})
    .then((response) => response.data);
};

export const getUsers = (config?: AxiosRequestConfig) => {
  return instance()
    .post<IUserModel[]>('/users/listPerformance', { search: config?.params.search }, config)
    .then((response) => response.data.map(({ username, firstLastName }) => ({ userId: username, fullName: firstLastName })));
};
